import { useEffect, useState } from 'react';
import { useMe, usePreferences } from '@nw/web-platform';

export type Atmosphere = 'aurora' | 'fog' | 'deep';

function hourIn(timeZone: string) {
  try {
    return Number(
      new Intl.DateTimeFormat('en-GB', {
        timeZone,
        hour: '2-digit',
        hour12: false,
      }).format(new Date()),
    );
  } catch {
    return new Date().getHours();
  }
}

/** Resolves the chosen atmosphere (auto = Aurora 07:00–19:00 in the workspace zone, Deep otherwise). Home's scene follows it. */
export function useAtmosphere(): Atmosphere {
  const prefs = usePreferences();
  const me = useMe();
  const [tick, setTick] = useState(0);
  const choice = prefs.data?.atmosphere ?? 'auto';
  const tz = me.data?.workspace.timezone ?? 'UTC';
  useEffect(() => {
    if (choice !== 'auto') return;
    const t = setInterval(() => setTick((n) => n + 1), 5 * 60_000);
    return () => clearInterval(t);
  }, [choice]);
  const hour = hourIn(tz);
  void tick;
  const resolved: Atmosphere = choice === 'auto' ? (hour >= 7 && hour < 19 ? 'aurora' : 'deep') : choice;
  useEffect(() => {
    const root = document.documentElement;
    root.dataset.atmosphere = resolved;
    const motionPref = prefs.data?.motionPreference ?? 'system';
    if (motionPref === 'system') delete root.dataset.motion;
    else root.dataset.motion = motionPref;
  }, [resolved, prefs.data?.motionPreference]);
  useEffect(() => {
    const root = document.documentElement;
    const sync = () => (root.dataset.hidden = document.hidden ? 'true' : 'false');
    sync();
    document.addEventListener('visibilitychange', sync);
    return () => document.removeEventListener('visibilitychange', sync);
  }, []);
  return resolved;
}
